import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
  },
  mainContainer: {
    width: '100%',
    maxWidth: '1300px',
  },
  flexContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  flexColumnContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  inputContainer: {
    marginBottom: theme.spacing(2),
    marginRight: theme.spacing(1),
    marginLeft: theme.spacing(1),
    width: '70%',
  },
  removeButtonContainer: {
    marginLeft: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },
  loadingProgress: {
    backgroundColor: 'rgba(255, 255, 255, 0.5)',
    zIndex: 1,
  },
  keyValuePairContainer: {
    gap: theme.spacing(2),
  },
  defaultOptionChip: {
    marginLeft: theme.spacing(1),
    fontSize: 12,
    height: 18,
    minWidth: 0,
  },
}));

export const useGeneratorsStyles = makeStyles(theme => ({
  codeMirror: {
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: theme.shape.borderRadius,
    resize: 'vertical',
    overflow: 'auto',
    '& .cm-editor': {
      fontSize: '14px',
    },
  },
  validationContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    gap: theme.spacing(2),
  },
  validationDefaultStyle: {
    color: '#9ca3af',
  },
  validationErrorStyle: {
    color: '#ef4444',
  },
  validationWarningStyle: {
    color: '#f59e0b',
  },
}));
